import { number, object } from 'yup'

export const cubicajeSchema = (alturaSilo) =>
  object().shape({
    metrosDeVacio: number()
      .typeError('El campo debe ser numerico')
      .required('Campo Obligatorio')
      .positive('Valor debe ser positivo')
      .lessThan(alturaSilo, 'El valor debe ser menor que la altura del silo'),
    ph: number()
      .typeError('El campo debe ser numerico')
      .notRequired()
      .positive('Valor debe ser positivo')
      .lessThan(100, 'Valor debe ser menor a 100')
  })
